import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import facetType from '../../../utility/types/facetType';
import { store } from '../../../redux/store';

class AlertQuietTimeFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = facetType.ALERT_QUIET_TIME;
    this.displayName = 'Alert Quiet Times';
    this.description = 'include...';
    this.storeState = store.getState();
  }

  getQuietTimeList() {
    return this.storeState.quietTimes
      ? this.storeState.quietTimes.quietTimeList
      : [];
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorTypeId = parseInt(operatorType, 10);
    const operatorDescriptions = {
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
      [OperatorTypes.EQUAL_TO_BOOLEAN]: 'ALL of the following:',
      [OperatorTypes.NOT_EQUAL_TO]: 'NONE of the following:',
    };
    return operatorDescriptions[operatorTypeId] || '';
  }

  /* istanbul ignore next */
  getName() {
    return this.displayName;
  }

  getDescription() {
    return this.description;
  }

  getDisplayValue1(value) {
    const quietTimes = this.getQuietTimeList();
    const foundQuietTime = quietTimes.find(
      (quietTime) => parseInt(quietTime.id, 10) === parseInt(value, 10),
    );
    return foundQuietTime ? foundQuietTime.name : '';
  }

  /* istanbul ignore next */
  // eslint-disable-next-line class-methods-use-this
  getValueSelectOptions(quietTimeList) {
    return quietTimeList.map((quietTime) => (
      { value: quietTime.id.toString(), label: quietTime.name }
    ));
  }

  // eslint-disable-next-line class-methods-use-this
  /* istanbul ignore next */
  getTooltip(filtersByOperatorObj) {
    const quietTimeList = this.getQuietTimeList();
    return `Alert Quiet Times are ${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
        ? `ANY of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_VALUE]
          .map((filter) => quietTimeList.find((quietTime) => parseInt(filter.value1, 10) === parseInt(quietTime.id, 10)).name).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
        ? ` ALL of ${filtersByOperatorObj[OperatorTypes.EQUAL_TO_BOOLEAN]
          .map((filter) => quietTimeList.find((quietTime) => parseInt(filter.value1, 10) === parseInt(quietTime.id, 10)).name).join(', ')
        };`
        : ''
    }${
      filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
        ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_EQUAL_TO]
          .map((filter) => quietTimeList.find((quietTime) => parseInt(filter.value1, 10) === parseInt(quietTime.id, 10)).name).join(', ')
        };`
        : ''
    }`;
  }
}

export default AlertQuietTimeFacet;
